module.exports = __webpack_public_path__ + "img/traffic-light-red.c82fa059.svg";